import store from '@/store'

export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error404.vue'),
    meta: {
      layout: 'main',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/Login.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
    }
  },
  {
    path: '/login-as-user',
    name: 'auth-login-as-user',
    component: () => import('@/views/LoginAsUser.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: false,
    }
  },
  {
    path: '/access-link/:token',
    name: 'auth-access-link',
    component: () => import('@/views/AccessLink.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: false,
    }
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/views/Registration/Register.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
    }
  },
  {
    path: '/reset-password/:token/:email',
    name: 'reset-password',
    component: () => import('@/views/ResetPassword.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
    }
  },
  {
    path: '/registration-staff',
    name: 'registration-staff',
    component: () => import('@/views/Registration/Register.vue'),
    meta: {
      role: 'staff',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      requiresAuth: false,
    }
  },
  {
    path: '/required-reset-password',
    name: 'required-reset-password',
    component: () => import('@/views/RequiredResetPassword.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: true,
    }
  },
  {
    path: '/programs',
    name: 'programs-list',
    component: () => import('@/views/Program/UpcomingPrograms.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: false,
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/Static/About.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: false,
    }
  },
  {
    path: '/home',
    name: 'home',
    component: async () => {
      const role = store.getters.getUserRole

      if (role === 'parent') {
        return await import('@/views/My/ChildApplications/ChildApplications.vue')
      } else {
        return await import('@/views/My/Applications.vue')
      }
    },
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: true,
    }
  },
  {
    path: '/my-tasks',
    name: 'tasks',
    component: () => import('@/views/Tasks/Tasks.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: true,
    }
  },
  {
    path: '/application-task/:id/:application_id',
    name: 'application-task-create',
    component: () => import('@/views/Tasks/ApplicationTaskAdd.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: true,
    }
  },
  {
    path: '/blog/:slug',
    name: 'post-details',
    component: () => import('@/views/Post/Post.vue'),
    meta: {
      redirectIfLoggedIn: false,
      requiresAuth: false,
    }
  },
  {
    path: '/my-family-list',
    name: 'family-list',
    component: () => import('@/views/Family/FamilyList.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: true,
    }
  },
  {
    path: '/archive-applications',
    name: 'archive-applications',
    component: () => import('@/views/My/ArchiveApplications.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: true,
    }
  },
  {
    path: '/payment-portal',
    name: 'payment-portal',
    component: () => import('@/views/PaymentPortal/PaymentPortal.vue'),
    meta: {
      resource: ['Auth', 'Payment Portal'],
      redirectIfLoggedIn: false,
      requiresAuth: true,
    }
  },
  {
    path: '/shop',
    name: 'product-catalog',
    component: () => import('@/views/Products/ProductCatalog.vue'),
    meta: {
      resource: 'Auth',
      redirectIfLoggedIn: false,
      requiresAuth: true,
    }
  },
]
